/**
 * @file price.ts
 *
 * @fileoverview Class representing price model containing utility functions.
 */
import { IntlShape } from 'react-intl';
import { CurrencyPlacementEnum } from '~/jobiqo/enums/currencyPlacement';
import { getCurrentFrontendConfig } from '~/jobiqo/context/frontendConfig';

export default class Price {
  constructor(
    private _priceNumber?: number | string,
    private _priceCurrency?: string,
    private _intl?: IntlShape,
  ) {
    this.formatNumber(_priceNumber);
  }

  private formatNumber(_priceNumber?: number | string) {
    if (_priceNumber) {
      if (this._intl) {
        this._priceNumber = this._intl.formatNumber(
          typeof _priceNumber === 'number'
            ? _priceNumber
            : parseFloat(_priceNumber),
          {
            minimumFractionDigits: 2,
          },
        );
      }
    } else {
      this._priceNumber = '';
    }
  }

  /**
   * Sets proper value and currency placement, adds spacing if needed.
   *
   * @returns Formatted price.
   */
  getPriceRepresentation(): string {
    if (!this._priceCurrency && !this._priceNumber) {
      return '';
    } else {
      if (this._priceNumber && !this._priceCurrency) {
        return this._priceNumber.toString();
      }
      if (!this._priceNumber && this._priceCurrency) {
        return this._priceCurrency;
      }

      const priceConfig = getCurrentFrontendConfig().APP.PRICE_CONFIG || {};
      const currencyPlacement = priceConfig.CURRENCY_PLACEMENT as CurrencyPlacementEnum;

      if (priceConfig.USE_SPACING) {
        return currencyPlacement === CurrencyPlacementEnum.BEFORE
          ? `${this._priceCurrency} ${this._priceNumber}`
          : `${this._priceNumber} ${this._priceCurrency}`;
      } else {
        return currencyPlacement === CurrencyPlacementEnum.BEFORE
          ? `${this._priceCurrency}${this._priceNumber}`
          : `${this._priceNumber}${this._priceCurrency}`;
      }
    }
  }
}
